export default {
  // list
  'bu_cost.column.orderId': '托单ID',
  'bu_cost.column.ladingOrderId': '提单ID',
  'bu_cost.column.transportOrderId': '运单ID',
  'bu_cost.column.businessType': '业务类型',
  'bu_cost.column.costItemId': '费用项目ID',
  'bu_cost.column.costItemName': '费用名称',
  'bu_cost.column.ourCompanyId': '本方公司ID',
  'bu_cost.column.contractCompanyId': '合同方公司ID',
  'bu_cost.column.costDate': '费用日期',
  'bu_cost.column.paymentDirection': '收支方向',
  'bu_cost.column.qty': '数量',
  'bu_cost.column.weight': '重量',
  'bu_cost.column.unitPrice': '单价',
  'bu_cost.column.totalAmount': '金额',
  'bu_cost.column.unitPriceExclTax': '不含税单价',
  'bu_cost.column.taxRate': '税率%',
  'bu_cost.column.taxAmount': '税额',
  'bu_cost.column.totalAmountExclTax': '不含税金额',
  'bu_cost.column.currencyCode': '币别',
  'bu_cost.column.settlementStatus': '对账状态',
  'bu_cost.column.genBillStatus': '生成账单状态',
  'bu_cost.column.rejectionReason': '驳回说明',
  'bu_cost.column.costBatchNo': '费用单号',
  'bu_cost.column.applyStatus': '申请状态',
  'bu_cost.column.paymentStatus': '收付款状态',
  // edit
  'bu_cost.edit.title': '编辑业务费用表',
  'bu_cost.add.title': '新增业务费用表',
  'bu_cost.edit.success': '编辑成功',
  'bu_cost.add.success': '新增成功',
  'bu_cost.form.orderId.required': '托单ID不能为空',
  'bu_cost.form.ladingOrderId.required': '提单ID不能为空',
  'bu_cost.form.businessType.required': '业务类型(集装箱、件杂货、拖车)不能为空',
  'bu_cost.form.costItemId.required': '费用项目ID不能为空',
  'bu_cost.form.costItemName.required': '费用项目名称不能为空',
  'bu_cost.form.ourCompanyId.required': '本方公司ID不能为空',
  'bu_cost.form.contractCompanyId.required': '合同方公司ID不能为空',
  'bu_cost.form.costDate.required': '费用日期不能为空',
  'bu_cost.form.paymentDirection.required': '收支方向不能为空',
  'bu_cost.form.qty.required': '数量不能为空',
  'bu_cost.form.totalAmount.required': '费用金额不能为空',
  'bu_cost.form.unitPriceExclTax.required': '不含税单价不能为空',
  'bu_cost.form.taxRate.required': '税率不能为空',
  'bu_cost.form.taxAmount.required': '税额不能为空',
  'bu_cost.form.totalAmountExclTax.required': '不含税金额不能为空',
  'bu_cost.form.currencyCode.required': '币别不能为空',
  'bu_cost.form.settlementStatus.required': '对账状态不能为空',
  'bu_cost.form.genBillStatus.required': '生成账单状态不能为空',
  'bu_cost.form.costBatchNo.required': '费用单号（同一个excel导入的费用）不能为空',
  'bu_cost.form.applyStatus.required': '申请状态不能为空',
  'bu_cost.form.paymentStatus.required': '收付款状态不能为空',
  'bu_cost.form.orderId': '托单ID',
  'bu_cost.form.orderId.placeholder': '请输入托单ID',
  'bu_cost.form.ladingOrderId': '提单ID',
  'bu_cost.form.ladingOrderId.placeholder': '请输入提单ID',
  'bu_cost.form.transportOrderId': '运单ID',
  'bu_cost.form.transportOrderId.placeholder': '请输入运单ID',
  'bu_cost.form.businessType': '业务类型(集装箱、件杂货、拖车)',
  'bu_cost.form.businessType.placeholder': '请输入业务类型(集装箱、件杂货、拖车)',
  'bu_cost.form.costItemId': '费用项目ID',
  'bu_cost.form.costItemId.placeholder': '请输入费用项目ID',
  'bu_cost.form.costItemName': '费用项目名称',
  'bu_cost.form.costItemName.placeholder': '请输入费用项目名称',
  'bu_cost.form.ourCompanyId': '本方公司ID',
  'bu_cost.form.ourCompanyId.placeholder': '请输入本方公司ID',
  'bu_cost.form.contractCompanyId': '合同方公司ID',
  'bu_cost.form.contractCompanyId.placeholder': '请输入合同方公司ID',
  'bu_cost.form.costDate': '费用日期',
  'bu_cost.form.costDate.placeholder': '请输入费用日期',
  'bu_cost.form.paymentDirection': '收支方向',
  'bu_cost.form.paymentDirection.placeholder': '请输入收支方向',
  'bu_cost.form.qty': '数量',
  'bu_cost.form.qty.placeholder': '请输入数量',
  'bu_cost.form.weight': '重量',
  'bu_cost.form.weight.placeholder': '请输入重量',
  'bu_cost.form.unitPrice': '单价',
  'bu_cost.form.unitPrice.placeholder': '请输入单价',
  'bu_cost.form.totalAmount': '费用金额',
  'bu_cost.form.totalAmount.placeholder': '请输入费用金额',
  'bu_cost.form.unitPriceExclTax': '不含税单价',
  'bu_cost.form.unitPriceExclTax.placeholder': '请输入不含税单价',
  'bu_cost.form.taxRate': '税率',
  'bu_cost.form.taxRate.placeholder': '请输入税率',
  'bu_cost.form.taxAmount': '税额',
  'bu_cost.form.taxAmount.placeholder': '请输入税额',
  'bu_cost.form.totalAmountExclTax': '不含税金额',
  'bu_cost.form.totalAmountExclTax.placeholder': '请输入不含税金额',
  'bu_cost.form.currencyCode': '币别',
  'bu_cost.form.currencyCode.placeholder': '请输入币别',
  'bu_cost.form.settlementStatus': '对账状态',
  'bu_cost.form.settlementStatus.placeholder': '请输入对账状态',
  'bu_cost.form.genBillStatus': '生成账单状态',
  'bu_cost.form.genBillStatus.placeholder': '请输入生成账单状态',
  'bu_cost.form.rejectionReason': '驳回说明',
  'bu_cost.form.rejectionReason.placeholder': '请输入驳回说明',
  'bu_cost.form.costBatchNo': '费用单号（同一个excel导入的费用）',
  'bu_cost.form.costBatchNo.placeholder': '请输入费用单号（同一个excel导入的费用）',
  'bu_cost.form.applyStatus': '申请状态',
  'bu_cost.form.applyStatus.placeholder': '请输入申请状态',
  'bu_cost.form.paymentStatus': '收付款状态',
  'bu_cost.form.paymentStatus.placeholder': '请输入收付款状态',
}
